import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  connectionProblemTitle: {
    id: 'offlineMode.connectionProblemTitle',
    defaultMessage: 'Yhteysongelma',
  },
  connectionProblemMessage: {
    id: 'offlineMode.connectionProblemMessage',
    defaultMessage:
      'Järjestelmä siirretty offline-tilaan. Offline-tilassa käytössä on vain ominaisuudet, jotka eivät edellytä internet yhteyttä. Kuormakirja ja työhön liittyvät kirjaukset tallentuu väliaikaisesti laitteen muistiin ja siirtyvät palvelimelle, kun yhteys on jälleen muodostettu.',
  },
})
